export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15114.cea5c581.jpg";